<template>
  <button
    class="icon-button"
    type="button"
    :title="title"
    @click="$emit('click')"
  >
    <FaIcon class="icon-button-icon" :icon="icon" />
  </button>
</template>

<script>
import FaIcon from './FaIcon'

export default {
  components: { FaIcon },
  props: {
    icon: {
      type: String,
      required: true,
    },

    /**
     *  The title to add to the button wrapping the icon.
     */
    title: { type: String, default: '' },
  },
}
</script>

<style lang="scss" scoped>
.icon-button {
  $size: 1.66em;

  font-size: 1.5em;
  display: block;
  width: $size;
  height: $size;
  line-height: 0.5em;
  background: transparent;
  border: none;
  border-radius: 100%;
  color: inherit;
  text-align: center;
  transition: all var(--transition-fast) ease-out;

  @media (hover: hover) {
    &:hover {
      background-color: rgba(255, 255, 255, 0.15);
    }
  }
}

.icon-button-icon {
  vertical-align: middle;
}
</style>
